import styled from "styled-components";

export const PageWrapper = styled.div`
  background: #1A1814;
  color: #F3ECE1;
  min-height: 100vh;
`;

export const Wrap = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding-inline: clamp(20px, 4.5vw, 64px);
`;

export const NavWrap = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding-inline: clamp(20px, 4.5vw, 64px);
`;

export const DownloadHeader = styled.section`
  padding-block: 72px 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px 48px;

  @media (max-width: 760px) {
    padding-block: 48px 28px;
  }
`;

export const HeaderContent = styled.div``;

export const ReadyBadge = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  font: 500 12px 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #D9442B;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #D9442B;
    box-shadow: 0 0 0 5px rgba(217, 68, 43, 0.18);
  }
`;

export const Title = styled.h1`
  margin: 18px 0 0;
  font: 400 clamp(52px, 6vw, 84px) / 0.95 'Instrument Serif', Georgia, serif;
  letter-spacing: -0.02em;

  em {
    color: #D9442B;
    font-style: italic;
  }
`;

export const Description = styled.p`
  margin: 18px 0 0;
  font-size: 19px;
  color: #CFC6B8;
  max-width: 28em;
`;

export const MetaStrip = styled.section`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 1px solid #F3ECE1;
  border-bottom: 1px solid #3A342C;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const MetaItem = styled.div`
  padding: 18px 20px 20px 0;

  & + & {
    padding-left: 20px;
    border-left: 1px solid #3A342C;
  }

  @media (max-width: 760px) {
    padding: 14px 0;

    & + & {
      padding-left: 0;
      border-left: 0;
      border-top: 1px solid #3A342C;
    }
  }
`;

export const MetaLabel = styled.span`
  display: block;
  font: 400 11px 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #A89E8F;
`;

export const MetaValue = styled.b`
  display: block;
  margin-top: 6px;
  font: 400 22px / 1.2 'Instrument Serif', Georgia, serif;
  letter-spacing: -0.005em;
  overflow-wrap: anywhere;
  font-weight: 400;
`;

export const FilesList = styled.ul`
  list-style: none;
  margin: 40px 0 0;
  padding: 0;
  display: grid;
  gap: 12px;
`;

export const FileItem = styled.li<{ $isPrimary?: boolean }>`
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr) auto;
  gap: 28px;
  align-items: center;
  padding: 20px 24px 20px 20px;
  background: #221F1A;
  border: 1px solid #3A342C;
  transition: border-color 0.15s;
  ${props => props.$isPrimary && 'border-top: 2px solid #D9442B;'}

  &:hover {
    border-color: #5A5349;
  }

  @media (max-width: 760px) {
    grid-template-columns: 64px minmax(0, 1fr);
    gap: 16px 18px;
    padding: 18px;
    align-items: start;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const FileThumbnail = styled.picture`
  img {
    display: block;
    width: 88px;
    height: 124px;
    object-fit: cover;
    box-shadow: 0 10px 24px -8px rgba(0, 0, 0, 0.7);
    outline: 1px solid rgba(243, 236, 225, 0.12);
    outline-offset: -1px;

    @media (max-width: 760px) {
      width: 64px;
      height: 90px;
    }
  }
`;

export const FileInfo = styled.div``;

export const FileTag = styled.span`
  font: 400 11px 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #D9442B;
`;

export const FileName = styled.h2`
  margin: 6px 0 4px;
  font: 400 30px / 1.05 'Instrument Serif', Georgia, serif;
  letter-spacing: -0.01em;

  @media (max-width: 760px) {
    font-size: 24px;
  }
`;

export const FileDescription = styled.p`
  margin: 0;
  font-size: 16.5px;
  color: #CFC6B8;
  max-width: 34em;
`;

export const FileSpec = styled.div`
  margin-top: 10px;
  font: 400 11px 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #6F675C;
`;

export const DownloadButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 22px;
  background: #F3ECE1;
  color: #1A1814;
  font: 500 15px 'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif;
  white-space: nowrap;
  transition: gap 0.2s ease;
  cursor: pointer;
  border-radius: 50px;

  &:hover {
    gap: 16px;
  }

  svg {
    width: 16px;
    height: 16px;
    stroke: #D9442B;
    fill: none;
    stroke-width: 2;
  }

  @media (max-width: 760px) {
    grid-column: 1 / -1;
    justify-content: center;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const NextSteps = styled.section`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-block: 40px 96px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 28px;
    margin-bottom: 64px;
  }
`;

export const NextCard = styled.div`
  border-top: 1px solid #F3ECE1;
  padding-top: 18px;
`;

export const CardLabel = styled.span`
  font: 400 11px 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #D9442B;
`;

export const CardTitle = styled.h3`
  margin: 10px 0 8px;
  font: 400 26px / 1.1 'Instrument Serif', Georgia, serif;
`;

export const CardDescription = styled.p`
  margin: 0;
  font-size: 16.5px;
  color: #CFC6B8;
  max-width: 28em;

  a {
    color: #F3ECE1;
    text-decoration: none !important;
    border-bottom: 1px solid #D9442B;

    &:hover {
      text-decoration: none !important;
    }
  }

  b {
    font-weight: 500;
  }
`;

export const Footer = styled.footer`
  border-top: 1px solid #3A342C;
`;

export const FooterContent = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding-inline: clamp(20px, 4.5vw, 64px);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px 32px;
  padding-block: 28px;
  font: 400 11px 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #6F675C;
`;

// Loading & Error states
export const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 24px;
  color: #CFC6B8;
  font-size: 16.5px;
`;

export const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 3px solid #3A342C;
  border-top-color: #D9442B;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ErrorState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 60vh;
  justify-content: center;
  padding: 40px 20px;
`;

export const ErrorIcon = styled.div`
  color: #D9442B;
  margin-bottom: 24px;
`;

export const ErrorTitle = styled.h1`
  font: 400 clamp(42px, 5vw, 64px) / 1 'Instrument Serif', Georgia, serif;
  letter-spacing: -0.02em;
  margin: 0 0 16px;
`;

export const ErrorMessage = styled.p`
  font-size: 19px;
  color: #CFC6B8;
  margin: 0 0 12px;
  max-width: 32em;
`;

export const ErrorInfo = styled.p`
  font-size: 16.5px;
  color: #A89E8F;
  margin: 0 0 32px;
  max-width: 32em;
`;

export const HomeButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  background: #F3ECE1;
  color: #1A1814;
  font: 500 15px 'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.9;
  }
`;
